import React, { useState } from 'react'
import { I18n } from 'react-redux-i18n'
import { useSelector, useDispatch, shallowEqual } from 'react-redux'

import { createProcess, updateProcess } from 'redux/smartchat/header/actions'
import ModalWrapper from 'components/ModalWrapper'
import { Text, Selector, ColorPicker } from 'components/SmartChatView/Fields'

const getCopyOptions = ({ processesList, processType }) => {
  if (processType === 'conversational') {
    return processesList.filter(process => process.processType === processType).map(process => ({ value: process._id, label: process.processName }))
  }
  if (processType === 'assistant') {
    return processesList.filter(process => ['conversational', 'assistant'].includes(process.processType)).map(process => ({ value: process._id, label: process.processName }))
  }
  if (processType === 'transactional') {
    return processesList.filter(process => process.processType === processType).map(process => ({ value: process._id, label: process.processName }))
  }
}

const ProcessModal = ({ isOpen, toggle, mode, processType, categoryId, processId }) => {
  const { processesList, modalLoading, modalError } = useSelector(store => ({
    processesList: store.smartchatHeader.processesList,
    modalLoading: store.smartchatHeader.modalLoading,
    modalError: store.smartchatHeader.modalError
  }), shallowEqual)
  const dispatch = useDispatch()
  const process = processesList.find(process => process._id === processId)
  const [processName, setprocessName] = useState(process?.processName || '')
  const [processColor, setProcessColor] = useState(process?.processColor || '#ffffff')
  const [copyValue, setCopyValue] = useState(null)
  const copyOptions = getCopyOptions({ processesList, processType })

  const handleSave = () => {
    if (mode === 'add') {
      dispatch(createProcess({
        processType,
        categoryId,
        processName,
        processColor,
        copyFrom: copyValue?.value || '',
        onFinish: toggle
      }))
    }

    if (mode === 'update') {
      dispatch(updateProcess({
        processId,
        processName,
        processColor,
        onFinish: toggle
      }))
    }
  }

  return (
    <ModalWrapper
      isOpen={isOpen}
      toggle={toggle}
      header={mode === 'add' ? I18n.t('dashboard_addProcess') : I18n.t('dashboard_edit-process')}
      legend={mode === 'add' ? I18n.t('dashboard_add-new-process') : I18n.t('chatbot_process_legend_update')}
      eventBtnTxt={mode === 'add' ? I18n.t('dashboard_create-process') : I18n.t('dashboard_edit-process')}
      eventBtn={handleSave}
      cancelBtnTxt={I18n.t('dashboard_cancel')}
      cancelBtn={toggle}
      isSubmitting={modalLoading}
      error={modalError && I18n.t(modalError.message)}
      contentClassName='smartchat-modal'
      body={
        <div className='modal-content modal-content--spaced'>
          {['add', 'update'].includes(mode) && processType !== 'conversational' && (
            <Text
              isRequired
              label={I18n.t('dashboard_process-name')}
              placeholder={I18n.t('dashboard_example_welcome')}
              value={processName}
              onChange={setprocessName}
            />
          )}
          {mode === 'add' && (
            <Selector
              isClearable
              label={I18n.t('chatbot_process_label_copy')}
              placeholder={I18n.t('dashboard_i-want-start-from-scratch')}
              options={copyOptions}
              value={copyValue}
              onChange={setCopyValue}
            />
          )}
          <ColorPicker
            isRequired
            label={I18n.t('dashboard_color')}
            value={processColor}
            onChange={setProcessColor}
          />
        </div>
      }
    />
  )
}

export default ProcessModal
